import React from "react";
import loadable from "@loadable/component";

export default {
	component: loadable(() => import(/* webpackChunkName: "homepage" */ "./ActionCard-click-slider"),{
		fallback: <div>Loading...</div>
	})
};
